import { render, staticRenderFns } from "./NsTextField.vue?vue&type=template&id=67ec2a3a&scoped=true&"
import script from "./NsTextField.vue?vue&type=script&lang=js&"
export * from "./NsTextField.vue?vue&type=script&lang=js&"
import style0 from "./NsTextField.vue?vue&type=style&index=0&id=67ec2a3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ec2a3a",
  null
  
)

export default component.exports